import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReviewService } from '../../../../../services/review.service';
import { Review } from '../../../../models/review.model';
import { ViewStatus } from '@uranda/ui';

interface RatingItem {
  label: string;
  rating: number;
}

@Component({
    selector: 'app-rating-breakdown',
    templateUrl: './rating-breakdown.component.html',
    styleUrls: ['./rating-breakdown.component.css'],
    standalone: false
})
export class RatingBreakdownComponent implements OnInit {
  @Input() reviewStats?: Review;
  @Input() showInRows = false;
  @Input() viewStatus = ViewStatus.READY;
  ViewStatus = ViewStatus;
  ratingData?: RatingItem[];
  questionKeyToLabelMap: { [key: string]: string };

  constructor(private translateService: TranslateService) {
    this.questionKeyToLabelMap = {
      'PROFESSIONALISM': this.translateService.instant('Professionalism'),
      'OVERALL_RATING': this.translateService.instant('Overall Rating'),
      'CLARITY_EXPLANATIONS': this.translateService.instant('Clarity of Explanations'),
      'RESPECT_TIMES': this.translateService.instant('Respect of Times'),
      'EASE_OF_REACH': this.translateService.instant('Ease of Reach'),
      'WOULD_RETURN': this.translateService.instant('Would Return'),
      'HYGIENIC_CONDITIONS': this.translateService.instant('Hygienic Conditions'),
      'TREATMENT_SATISFACTION': this.translateService.instant('Treatment Satisfaction'),
      'APPOINTMENT_MANAGEMENT': this.translateService.instant('Appointment Management'),
      'COST_TRANSPARENCY': this.translateService.instant('Cost Transparency')
    };
  }

  ngOnInit() {
    if (this.reviewStats?.questionAverages) {
      this.loadRatingBreakdown();
    }
  }

  ngOnChanges() {
    if (this.reviewStats?.questionAverages) {
      this.loadRatingBreakdown();
    }
  }

  private loadRatingBreakdown() {
    this.ratingData = Object.entries(this.reviewStats!.questionAverages)
      .map(([key, rating]) => ({
        label: this.translateService.instant(this.questionKeyToLabelMap[key] || key),
        rating: Math.round(rating * 100) / 100 
      }))
      .sort((a, b) => b.rating - a.rating);
  }
}